
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revival",
      function () {
        return require("private-next-pages/revival/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/revival"])
      });
    }
  